import { isAfter, isBefore, isEqual } from 'date-fns';

import type { Error, Validator } from '../types';

type ValidatorFunction = (
  compareValue?: number,
  message?: Error['message'],
  allowEmpty?: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) => (value: any) => Error;

const validateDate =
  (preposition: 'equalOrBefore' | 'equalOrAfter') =>
  (compare?: string | number, message?: Error['message']) =>
  (value?: string | number): Error => {
    let valid = false;
    if (!compare || value === undefined || value === null) {
      valid = true;
    } else {
      const valueDate = new Date(value);
      const compareDate = new Date(compare);
      valid =
        isEqual(valueDate, compareDate) ||
        (preposition === 'equalOrBefore'
          ? isBefore(valueDate, compareDate)
          : isAfter(valueDate, compareDate));
    }
    return { valid, message };
  };

const validateDateComparedWith =
  (
    compareDateProperty: string,
    message: Error['message'],
    validatorFunction: ValidatorFunction
  ): Validator =>
  (value, allValues) =>
    validatorFunction(allValues && allValues[compareDateProperty], message)(value);

export const equalOrBeforeDate = validateDate('equalOrBefore');

export const equalOrAfterDate = validateDate('equalOrAfter');

export const equalOrBeforeDateComparedWith = (
  compareDateProperty: string,
  message?: Error['message']
) => validateDateComparedWith(compareDateProperty, message, equalOrBeforeDate);

export const equalOrAfterDateComparedWith = (
  compareDateProperty: string,
  message?: Error['message']
) => validateDateComparedWith(compareDateProperty, message, equalOrAfterDate);
